export default {
    org_columns: [],
    namespaced: true,
    state: {
      type:"CampaignQueryModel",
      selected_columns: [],
      disableSearchButton: true,
      sort_by: "",
      sort_direction: "DESC",
      excluded_rows:[],
      payload: {
        site_id: [],
        start_date: "",
        end_date: "",
        group_by: { 
          id:"nobody", 
          label:"-Ingen-"
        },
        consolidationPeriods: [],
        columns: [],
        measures: [],
        product: -1,
        advertiser: -1,
        buyingAgency: -1,
        filmcodes: [],
        productClasses:[],
        filmTypes: [],
        consumption_date_start: "1900-01-01",
        lastRowNum: 0
      }
    }, 
    getters: {
      getPayload: state => {
        return state.payload
      },
    },
    mutations: {
          
      updateExcludedRows(state, rownr) {
        if (rownr && rownr.length) {
          state.excluded_rows = [...state.excluded_rows, ...rownr];
        } else {
          state.excluded_rows = [];
        }
      },
      updateLastRowNum(state, newLastRowNum) {
        state.payload.lastRowNum = newLastRowNum;
      },
      updateSortBy(state, newSortBy) {    
        state.sort_by = newSortBy;    
      },
      updateSortDirection(state, newSortDirection) {
        state.sort_direction = newSortDirection;
      },
      updateStartDate(state, newStartDate) {
        state.payload.start_date = newStartDate;
      },
      updateGroupBy(state, newGroupBy) {
        state.payload.group_by = newGroupBy;
      },
      updatePeriod(state, newSelectedPeriod) {
        state.payload.selectedPeriod = newSelectedPeriod;
      },
      updateEndDate(state, newEndDate) {
        state.payload.end_date = newEndDate;
      },
      updateSiteIds(state, newSiteIds) {
        state.payload.site_id = newSiteIds;
      },
      updateMeasures(state, newMeasures) {
        state.payload.measures = newMeasures;
      },
      updateAdvertiser(state, newAdvertiser) {
        state.payload.advertiser = newAdvertiser;
      },
      updateBuyingAgency(state, newBuyingAgency) {   
        state.payload.buyingAgency = newBuyingAgency;
      },
      updateProduct(state, newProduct) {
        state.payload.product = newProduct;
      },
      updateFilmCodes(state, newFilmcodes){
        state.payload.filmcodes = newFilmcodes;
      },
      updateProductClasses(state, newProductClasses)
      {
        state.payload.productClasses = newProductClasses;
      },
      emptyQueryKeys(state) {
        state.payload.queryKeys = [];
      },
      updateColumns(state, newColumns) {     
        this.org_columns = newColumns;
        let requiredColumns = [];
        //state.payload.columns = newColumns.concat(requiredColumns);
      // unika kolumner
        state.payload.columns = [...new Set([...newColumns, ...requiredColumns])];
        state.payload.selected_columns = newColumns;
        state.disableSearchButton = false; 
      },
      updateFilmTypes(state, newFilmTypes){     
        state.payload.filmTypes = newFilmTypes; 
      },
      updateConsolidationPeriods(state, newConsolidationPeriods) {
        state.payload.consolidationPeriods = newConsolidationPeriods;
      },
      updatePayload(state, newPayload) {
        state.payload = newPayload;
      }

    }
  };
  